import { WeaTools } from 'ecCom'

export const getSearchCondition = (params) => {
    return WeaTools.callApi('/api/hrm/schedulediffmonthattdetail/getSearchCondition', 'POST', params);
}

export const getReportData = (params) => {
    return WeaTools.callApi('/api/hrm/schedulediffmonthattdetail/getReportData', 'POST', params);
}

export const getTableData = params => {
    return WeaTools.callApi('/api/hrm/schedulediffmonthattdetail/getReportDetialData', 'POST', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/schedulediffmonthattdetail.js